import React from 'react';
import Select from 'react-select';
import { FaTrash } from 'react-icons/fa';
import showAlert from '../../utils/alert';

const CompanyAccountTable = ({
  validItems = [],
  items = [],
  setItems = () => {},
  companies = { data: [] },
  accountCodeList = [],
  compactSelectStyles = {}
}) => {
    const handleCompanyChange = (selectedOption, idx) => {
        const selectedCompanyId = String(selectedOption.value);
        const isDuplicate = items.some(
          (item) => String(item.company?.id) === selectedCompanyId
        );
        if (isDuplicate) {
          showAlert('This company has already been added.', 'error');
          return;
        }
              const updated = [...items];
        updated[idx].company = { id: selectedOption.value, name: selectedOption.label };
        setItems(updated);
      };

  const handleAccountCodeChange = (selectedOption, idx) => {
    const updated = [...items];
    updated[idx].accountCode = { id: selectedOption.value, name: selectedOption.label };
    setItems(updated);
  };

  const handleDelete = (idx) => {
    const updated = items.filter((_, i) => i !== idx);
    setItems(updated);
  };

  if (validItems.length === 0) return null;

  return (
<div>
<div className="relative max-h-[20vh]">
    <table className="w-full text-sm text-gray-700 bg-white">
    <thead className="company-acount-table sticky top-0 z-0 bg-white shadow-md h-10">
          <tr>
        <th className="w-1/2 px-4 py-2 text-black font-bold opacity-75 text-left text-xs">COMPANY</th>
        <th className="w-2/5 px-4 py-2 text-black font-bold opacity-75 text-left text-xs">ACCOUNT CODE</th>
        <th className="px-4 py-2 text-black font-bold opacity-75 text-left text-xs">
        <span className="sr-only">Actions</span>
        </th>
          </tr>
    </thead>
        <tbody>
          {validItems.map((item, idx) => (
            <tr key={item.company.id} className="even:bg-gray-50">
              <td className="px-4 py-3">
                  <Select
                    styles={{
                      ...compactSelectStyles,
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                      menu: (base) => ({ ...base, zIndex: 9999, position: 'absolute' })
                    }}
                    menuPosition="fixed"
                    menuPortalTarget={document.body}
                    options={companies?.data.map((c) => ({
                      value: c.id,
                      label: c.name
                    }))}
                    value={{ value: item.company.id, label: item.company.name }}
                    onChange={(option) => handleCompanyChange(option, idx)}
                  />
              </td>
              <td className="px-4 py-3">
                  <Select
                   styles={{
                    ...compactSelectStyles,
                    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    menu: (base) => ({ ...base, zIndex: 9999, position: 'absolute' })
                  }}
                    menuPosition="fixed"
                    menuPortalTarget={document.body}
                    options={accountCodeList.map((a) => ({
                      value: a.accountCodeID,
                      label: a.accountCode
                    }))}
                    value={{ value: item.accountCode.id, label: item.accountCode.name }}
                    onChange={(option) => handleAccountCodeChange(option, idx)}
                  />
              </td>
                <td className="px-4 py-2">
                  <button
                    type="button"
                    onClick={() => handleDelete(idx)}
                    className="text-red-500 hover:text-red-700 font-medium"
                  >
                    <FaTrash size={14} color="rgba(131, 131, 131, 1)" />
                  </button>
                </td>
            </tr>
          ))}
        </tbody>
    </table>
</div>
</div>
  );
};

export default CompanyAccountTable;
